import { tabletBreakpoint } from 'core/layouts/ui-blocks/ReusableStyles';
import { colorPalette } from 'core/layouts/ui-blocks/ColorPalette';

export const footerNavigationLinksCardStyles = {
	footerTextButton: {
		padding: 0,
		minWidth: 'unset',

		display: 'flex',
		alignItems: 'center',
		gap: '4px',

		textDecoration: 'none',
		textTransform: 'none',

		'& svg': { height: '24px', width: 'auto' },
	},
	footerText: {
		color: 'colors.light5',

		'> ul': {
			paddingInlineStart: { xs: 0, [tabletBreakpoint]: '40px' },
			marginBlockStart: 0,
			marginBlockEnd: 0,

			'> li': {
				listStyleType: { xs: 'none', [tabletBreakpoint]: 'disc' },
			},
		},
	},
	footerDivider: {
		width: '100%',
		borderBottom: `1px solid ${colorPalette.dark4}`,
	},
};
